import { render, staticRenderFns } from "./slide.vue?vue&type=template&id=279051ad&scoped=true&"
import script from "./slide.vue?vue&type=script&lang=js&"
export * from "./slide.vue?vue&type=script&lang=js&"
import style0 from "./slide.vue?vue&type=style&index=0&id=279051ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279051ad",
  null
  
)

export default component.exports